import { ServiceProvider } from "../../../../domain/service_provider/ServiceProvider";
import { useSelector } from "react-redux";
import { State } from "../../../../state/store";
import { ServiceProviderName } from "../../../../domain/service_provider/ServiceProviderName";
import { ServiceProviderId } from "../../../../domain/service_provider/ServiceProviderId";

export const useServiceProviderList = (): ServiceProvider[] | null => {
    const list = useSelector((state: State) => state.adminServiceProvider.serviceProviders);

    return list?.map(json => {
        return ServiceProvider.fromIdName(
            ServiceProviderId.fromString(json.id),
            ServiceProviderName.fromString(json.name)
        );
    }) ?? null;
};
